<script lang="ts" >
    import Navigation from "../common/navigation.component.svelte";

    // Export
    // -- Title
    export let title = "";
    // -- Next Enable
    export let nextEnable = false;
    // -- Image index
    export let imageIndex: number;

</script>

<div class="wrapper">
    <header class="header">
        <h1 class="page-title">
            { title }
        </h1>
    </header>
    <aside class="sidebar">
        <slot name="presentation" >
            Contenu par défaut qui doit être changé
        </slot>
    </aside>

    <div class="middle">
        {#if imageIndex % 2 == 1 }
        <div class="image">
            <img src="./img/{imageIndex}.png" alt="{ title }" />
        </div>
        {/if}
        <div class="content" >
            <slot name="content" >
    
            </slot>
        </div>
        {#if imageIndex % 2 == 0 }
        <div class="image">
            <img src="./img/{imageIndex}.png" alt="{ title }" />
        </div>
        {/if}
    </div>

    <footer class="footer">
        <Navigation 
            {nextEnable} 
            on:navigation-next
            
        />
    </footer>

</div>

<style>

    .sidebar {
        text-align: justify;
        margin-top: 20px;
    }
    
    
    .middle {
        display: flex;
        
        margin: 20px 20px;
    }

    .image {
        align-self: center;
    }

    .middle > .content {
        flex:auto;
    }
</style>

